<div class="icon-status-container" [ngStyle]="style">
  <mat-icon *ngIf="name" class="icon-status" [ngStyle]="{ color: color }">
    {{ name }}
  </mat-icon>
  <div class="status-name">{{ label }}</div>
</div>
